module.exports = "images/france-5.83c04305.png";